/**************************************************
 * 用户信息
 **************************************************/
export const SET_PERMISSIONS = 'SET_PERMISSIONS';
export const SET_USERINFO = 'SET_USERINFO';

/**************************************************
 * IP SERVER信息
 **************************************************/
export const SET_SERVER_GAME = 'SET_SERVER_GAME';
export const SET_SERVER_WORLD = 'SET_SERVER_WORLD';



// WEBPACK FOOTER //
// ./src/vuex/mutation_types.js